import type { Rule } from "antd/lib/form";

import { type ValidationRule, type ValidationRuleParams, ValidationType } from "../../types/types";
import { getNumberMaxRule } from "./validationRules/Max";
import { getMaxLengthRule } from "./validationRules/MaxLength";
import { getNumberMinRule } from "./validationRules/Min";
import { getMinLengthRule } from "./validationRules/MinLength";
import { getPatternRule } from "./validationRules/Pattern";
import { getRequiredRule } from "./validationRules/Required";

const ValidationFieldsMap: Record<ValidationType, (validationRule: ValidationRuleParams) => Rule | undefined> = {
    [ValidationType.VALIDATION_REQUIRED]: getRequiredRule,
    [ValidationType.VALIDATION_MIN_LENGTH]: getMinLengthRule,
    [ValidationType.VALIDATION_MAX_LENGTH]: getMaxLengthRule,
    [ValidationType.VALIDATION_MIN]: getNumberMinRule,
    [ValidationType.VALIDATION_MAX]: getNumberMaxRule,
    [ValidationType.PATTERN]: getPatternRule,
};

export const getValidationRules = (validationRule: ReadonlyArray<ValidationRule> | undefined) => {
    const rules = [] as Rule[];

    validationRule?.forEach((rule) => {
        const validationMethod = ValidationFieldsMap[rule.name];
        if (validationMethod) {
            const params = rule.params || [];
            const validation = validationMethod(params);
            if (validation) {
                rules.push(validation);
            }
        }
    });

    return rules;
};
